let pendingSessionFingerprint: string | null = null;

export const beginAccountSwitchTransition = (
  sessionFingerprint: string,
): void => {
  pendingSessionFingerprint = sessionFingerprint;
};

export const clearAccountSwitchTransition = (
  sessionFingerprint?: string,
): void => {
  if (
    sessionFingerprint !== undefined &&
    pendingSessionFingerprint !== sessionFingerprint
  ) {
    return;
  }
  pendingSessionFingerprint = null;
};

export const getPendingAccountSwitchFingerprint = (): string | null =>
  pendingSessionFingerprint;

export const isAccountSwitchTransitionPending = (): boolean =>
  pendingSessionFingerprint !== null;
